import { BaseApi } from '@/api/BaseApi';
import { Subscription, SubscriptionRequest } from '@/types/report';

/** Подписка на отчет */
export default class SubscriptionApi extends BaseApi<Subscription, SubscriptionRequest> {
    byUser(userId: string): Promise<Subscription[]> {
        return this.instance.get<Subscription[]>(`${this.entityName}/GetByUser/${userId}`).then(x => x.data);
    }
}
